import React from 'react';
import ExternalPostPlatformIcon from '../components/ExternalPostPlatformIcon';
import useIsLayoutSize from '../post/utils/useIsLayoutSize';
import { LayoutSize } from '../post/utils/useLayoutSize';
import { externalDisplayName } from '../utils/post/externalPost';
import SidebarRow from './SidebarRow';
import SidebarSection from './SidebarSection';
import SidebarSectionIcon from './SidebarSectionIcon';
import SidebarSectionOverflowMenuItems from './SidebarSectionOverflowMenuItems';
import { PremadeSections } from './SidebarSectionsProvider';
import useExternalPostPlatforms from './useExternalPostPlatforms';

interface SidebarExternalPostsSectionProps {
  onMoveSectionUp?: () => void;
  onMoveSectionDown?: () => void;
}

const SidebarExternalPostsSection = ({
  onMoveSectionUp,
  onMoveSectionDown,
}: SidebarExternalPostsSectionProps) => {
  const platforms = useExternalPostPlatforms();
  const isMobile = useIsLayoutSize(LayoutSize.mobile);

  if (platforms.length === 0) {
    return null;
  }

  return (
    <SidebarSection
      hasChildren={platforms.length > 0}
      id="apps"
      icon={<SidebarSectionIcon section={{ id: 'integrations' }} />}
      title="Integrations"
      menuItems={
        !isMobile && (
          <SidebarSectionOverflowMenuItems
            selectedSectionId={PremadeSections.INTEGRATIONS}
            onMoveSectionUp={onMoveSectionUp}
            onMoveSectionDown={onMoveSectionDown}
          />
        )
      }
    >
      {platforms.map(
        ({ id }) =>
          id && (
            <SidebarRow
              key={id}
              to={`/integration-posts/${id}`}
              icon={<ExternalPostPlatformIcon id={id} size="regular" />}
              level={1}
            >
              {externalDisplayName(id)}
            </SidebarRow>
          ),
      )}
    </SidebarSection>
  );
};

export default SidebarExternalPostsSection;
